'use client';

import { useEffect, useState } from 'react';

const TAGLINES = [
  'SOLUCIONES DE PRIMERA LÍNEA',
  'GESTIÓN DE CAPITAL HUMANO',
  'CONSULTORÍA ESTRATÉGICA',
];

/** Ported as-is from scripts.js banner 8 (index hero, type/delete state machine). */
export default function HeroTypingText() {
  const [text, setText] = useState('');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let taglineIndex = 0;
    let charIndex = 0;
    let isDeleting = false;
    let timer: ReturnType<typeof setTimeout>;

    function type() {
      const current = TAGLINES[taglineIndex];
      let typeSpeed: number;

      if (!isDeleting) {
        typeSpeed = 100;
        setText(current.substring(0, charIndex + 1));
        charIndex++;
        if (charIndex === current.length) {
          isDeleting = true;
          typeSpeed = 3000;
        }
      } else {
        setText(current.substring(0, charIndex - 1));
        charIndex--;
        typeSpeed = 50;
        if (charIndex === 0) {
          isDeleting = false;
          taglineIndex = (taglineIndex + 1) % TAGLINES.length;
          typeSpeed = 1000;
        }
      }

      timer = setTimeout(type, typeSpeed);
    }

    const startTimer = setTimeout(() => {
      setVisible(true);
      type();
    }, 1500);

    return () => {
      clearTimeout(startTimer);
      clearTimeout(timer);
    };
  }, []);

  return (
    <span id="hero-tagline" className={visible ? 'tagline-visible' : ''}>
      {text}
    </span>
  );
}
